import React, { useEffect, useState } from "react";
import Swiper from "swiper";

const ReviewSwiper = ({ logic, locationData }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(`/api/google-reviews/${locationData}`);
        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }
        return await response.json();
      } catch (error) {
        console.error('Error fetching reviews:', error);
        setLoading(false);
        return [];
      }
    };
  
    const fetchManualReviews = async () => {
      try {
        const response = await fetch("/rest/manual-reviews?_format=hal_json", {
          headers: { "Accept": "application/json" }
        });
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const data = await response.json();

        const filteredData = data.filter((item) => {return item.field_review_location === locationData});

        return filteredData;
      } catch (err) {
        setError(err.message);
        return [];
      }
    };
  
    const fetchData = async () => {
      setLoading(true);
      let manualData = [];
      let scrapedData = [];
  
      switch (logic) {
        case "mix_reviews":
          manualData = await fetchManualReviews();
          scrapedData = await fetchReviews();
          setReviews([...manualData, ...scrapedData]);
          break;
        case "show_only_handmade_reviews":
          manualData = await fetchManualReviews();
          setReviews(manualData);
          break;
        case "show_only_scraped_reviews":
          scrapedData = await fetchReviews();
          setReviews(scrapedData);
          break;
        default:
          const defaultData = await fetchReviews();
          setReviews(defaultData);
          break;
      }
  
      setLoading(false);
    };
  
    fetchData();
  
  }, [logic]);  

  const initializeSwiper = () => {
    let mySwiper;

    // Destroy existing Swiper instance if it exists
    if (mySwiper) {
      mySwiper.destroy(true, true);
    }

    // Create a new Swiper instance with pagination
    mySwiper = new Swiper(".swiper-container-review", {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      loop: true,
      breakpoints: {
        1024: {
          spaceBetween: 30,
        },
      },
      autoplay: {
        delay: 10000,
      },
      navigation: {
        nextEl: ".swiper-button-next-review",
        prevEl: ".swiper-button-prev-review",
      },
      /* pagination: {
        el: ".swiper-pagination",
        clickable: true, // Allow pagination bullets to be clickable
      }, */
      threshold: 50,
    });
  };

  useEffect(() => {
    if (reviews) {
      initializeSwiper();
    }
  }, [reviews]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="review-section">
      <div className="swiper-container-review">
        <div className="swiper-wrapper">
          {reviews && reviews.length > 0 &&
            reviews.map((item, index) => {
              const numberOfStars = item?.rating;
              const starsArray = Array.from({ length: numberOfStars }, (_, starIndex) => starIndex);

              return (
                <div className="swiper-slide review-card" key={index}>
                  <div className="review-card--text">
                    <div dangerouslySetInnerHTML={{__html: item.text}}></div>
                  </div>
                  <div className="review-card--star">
                    {starsArray.map((star, starIndex) => (
                      <svg key={starIndex} fill="#FCBF02" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" /></svg>
                    ))}
                  </div>
                  <div className="review-card--img">
                    <img src={item.profile_photo_url} />
                  </div>
                  <div className="review-card--author">
                    {item.author_name}
                  </div>
                  <div className="review-card--time">
                    {item.relative_time_description}
                  </div>
                </div>
              )
            })}
        </div>
      </div>
      {/* {windowWidth > 1024 ? (
        <> */}
          {reviews && reviews.length >= 1 && (
            <div className="swiper-controller">
              <div className="swiper-button-next-review">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26.07 21.19"
                >
                  <title>next</title>
                  <path
                    id="path-1"
                    d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                    transform="translate(0 -0.12)"
                  ></path>
                </svg>
              </div>
              <div className="swiper-button-prev-review">
                <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26.07 21.19"
                >
                  <title>next</title>
                  <path
                    id="path-1"
                    d="M23,12H1a1,1,0,0,1-1-1H0a1,1,0,0,1,1-1H23L14.73,1.84a1,1,0,0,1,0-1.41l0,0h0a1.05,1.05,0,0,1,1.47,0l9.26,9.16a2,2,0,0,1,0,2.83l-.06.06L16.26,21a1.08,1.08,0,0,1-1.52,0h0a1,1,0,0,1,0-1.47l0,0Z"
                    transform="translate(0 -0.12)"
                  ></path>
                </svg>
              </div>
            </div>
          )}
        {/* </>
      ) : ( */}
        {/* <div className="swiper-pagination"></div>
      )} */}
    </div>
  );
};

export default ReviewSwiper;